const LLReversalProblems = [
  {
      title: "Reverse Linked List",
      url: "https://leetcode.com/problems/reverse-linked-list/"
    },
    {
      title: "Reverse Linked List II",
      url: "https://leetcode.com/problems/reverse-linked-list-ii/"
    },
    {
      title: "Swap Nodes in Pairs",
      url: "https://leetcode.com/problems/swap-nodes-in-pairs/"
    },
    {
      title: "Reverse Nodes in k-Group",
      url: "https://leetcode.com/problems/reverse-nodes-in-k-group/description/"
    },
    {
      title: "Rotate List",
      url: "https://leetcode.com/problems/rotate-list/"
    }
];
export default LLReversalProblems;